module.exports = __webpack_public_path__ + "static/media/stove-timer.e13807f7.png";